import type { PlanStop } from '@trippath/shared';

/** A stop with its place in the whole route, for moving it. */
export interface Placed {
  stop: PlanStop;
  at: number;
}

/** A country's stops in a row, as the route list and the timeline show them. */
export interface Run {
  country: string;
  stops: Placed[];
  days: number;
}

/** Stops in a row grouped by country, each with its place in the route. */
export function runs(stops: PlanStop[]): Run[] {
  const out: Run[] = [];
  stops.forEach((stop, at) => {
    const last = out[out.length - 1];
    if (last?.country === stop.country) {
      last.stops.push({ stop, at });
      last.days += stop.days;
    } else {
      out.push({ country: stop.country, stops: [{ stop, at }], days: stop.days });
    }
  });
  return out;
}
